import ApiError from "../../errors/ApiError";
import { CREATE_ROOM_ERP_INTEGRATIONS_ERROR } from "./error-codes.constants";

export class CreateRoomErpIntegrationsError extends ApiError {
  constructor() {
    super(CREATE_ROOM_ERP_INTEGRATIONS_ERROR);
  }
}
